<template>
    <div class="overdue-claims-font">
        <div class="row">
            <div class="col title text-muted">{{ title }}</div>
            <div class="col-md-auto"><a :href="hrefMore">More...</a></div>
        </div>
        <div v-if="documents.length" class="table-responsive">
            <table class="table table-sm">
                <thead>
                    <th>Claim Number</th>
                    <th>PAN</th>
                    <th>DOS</th>
                    <th>Patient</th>
                    <th>Provider</th>
                    <th>Payer</th>                   
                    <th class="text-right">Est. Reimb.</th>
                    <th class="text-right">Balance</th>
                    <th class="text-right">Days Overdue</th>
                </thead>
                <tbody>
                    <tr v-for="document in documents" :key="'overdue-claim-payments-' + document.service_form_id">
                        <td><a :href="document.href" v-text="document.claim_number"></a></td>
                        <td><a :href="document.services_href" v-text="document.pan"></a></td>
                        <td><a :href="document.services_href" v-text="document.dos"></a></td>
                        <td><a :href="document.href" v-text="document.patient_name"></a></td>
                        <td :title="document.rendering_provider_name">{{ document.rendering_provider_name | truncate(25) }}</td>
                        <td :title="document.payer_name">{{ document.payer_name| truncate(25) }}</td>
                        <td class="text-right">{{ document.estimated_reimbursement | currency }}</td>
                        <td class="text-right">{{ document.balance | currency }}</td>
                        <td class="text-right">{{ document.days_overdue }}</td>              
                    </tr>
                </tbody>
            </table>
        </div>
        <div v-else class="border-top pt-2">
            <h5 class="text-muted text-center">No {{ title }}</h5>
        </div> 
    </div>
</template>

<script>
export default {
    props: {
        title: String,
        href: String,
        hrefMore: String
    },
    data() {
        return {
            documents: []
        }
    },
    mounted() {
        axios.get(this.href)
            .then(response => {
                this.documents = response.data;
            });
    }
}
</script>

<style scoped>
    .overdue-claims-font {
        font-size: 12px;
        font-family: 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;
        font-style: normal;
        font-weight: bold;
        color: #666;
    }   
</style>


